import {padCharsStart} from 'lodash/fp';

export const editDateNumber = (value: number): string => padCharsStart('0')(2)(String(value));
